const MIN_INLINE_WIDTH = 1080;

class S71Header extends HTMLElement {
  constructor() {
    super();

    this.toggle = this.querySelector('[data-s71-toggle]');
    this.nav = this.querySelector('[data-s71-nav]');
    this.overlay = this.querySelector('[data-s71-overlay]');
    this.mark = null;
    this.solidAt = Number(this.dataset.solidAt || 35) / 100;
    this.isOpen = false;

    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);
    this.onKeyUp = this.onKeyUp.bind(this);

    if (this.toggle) {
      this.toggle.addEventListener('click', () => this.setOpen(!this.isOpen));
    }

    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.setOpen(false));
    }

    this.addEventListener('keyup', this.onKeyUp);
  }

  connectedCallback() {
    this.mark = document.querySelector('.s71-header__mark');
    this.updateLayout();
    this.publishHeight();
    this.updateSolidState();
    this.updateMarkContrast();

    document.fonts?.ready.then(() => {
      this.updateLayout();
      this.publishHeight();
    });

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize, { passive: true });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
    this.setOpen(false);
  }

  onScroll() {
    if (this.frame) return;

    this.frame = requestAnimationFrame(() => {
      this.frame = null;
      this.updateSolidState();
      this.updateMarkContrast();
    });
  }

  onResize() {
    if (this.resizeFrame) return;

    this.resizeFrame = requestAnimationFrame(() => {
      this.resizeFrame = null;
      this.updateLayout();
      this.publishHeight();
    });
  }

  updateLayout() {
    const inline = window.innerWidth >= MIN_INLINE_WIDTH && this.navFitsInline();

    if (this.isOpen && inline) {
      this.setOpen(false);
    }

    if (this.isOpen) return;

    this.dataset.s71Layout = inline ? 'inline' : 'drawer';
  }

  navFitsInline() {
    const list = this.querySelector('.s71-header__list');
    if (!list) return true;

    const previous = this.dataset.s71Layout || 'drawer';
    this.dataset.s71Measuring = '';
    this.dataset.s71Layout = 'inline';
    const fits = list.scrollWidth <= list.clientWidth;
    this.dataset.s71Layout = previous;
    delete this.dataset.s71Measuring;

    return fits;
  }

  onKeyUp(event) {
    if (event.code !== 'Escape' || !this.isOpen) return;
    this.setOpen(false);
    this.toggle?.focus();
  }

  publishHeight() {
    const bar = this.querySelector('[data-s71-bar]');
    if (!bar) return;

    document.documentElement.style.setProperty('--s71-header-height', `${Math.round(bar.offsetHeight)}px`);
  }

  flushSection() {
    return document.querySelector('#MainContent > :first-child [data-s71-flush]');
  }

  updateSolidState() {
    if (!this.classList.contains('s71-header--overlay')) return;

    let solid = true;
    const flush = this.flushSection();

    if (flush) {
      const rect = flush.getBoundingClientRect();
      const progress = rect.height > 0 ? -rect.top / rect.height : 1;
      solid = progress >= this.solidAt;
    }

    this.classList.toggle('s71-header--solid', solid);
  }

  updateMarkContrast() {
    if (!this.mark || getComputedStyle(this.mark).display === 'none') return;

    const rect = this.mark.getBoundingClientRect();
    const behind = document.elementFromPoint(rect.left + rect.width / 2, rect.top + rect.height / 2);
    const surface = behind?.closest('[data-s71-surface]');

    this.mark.classList.toggle('s71-header__mark--dark', surface?.dataset.s71Surface === 'light');
  }

  setOpen(open) {
    if (open === this.isOpen) return;

    this.isOpen = open;
    this.classList.toggle('s71-header--open', open);
    this.toggle?.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('s71-scroll-locked', open);

    if (open) {
      trapFocus(this.nav, this.nav.querySelector('a, button'));
    } else {
      removeTrapFocus(this.toggle);
    }
  }
}

customElements.define('s71-header', S71Header);
